module.exports = __webpack_public_path__ + "img/Journalisma6.a978c132.png";